import { createSlice } from "@reduxjs/toolkit";


export const wishSlice = createSlice({
    name:'wishlist',
    initialState:{
        wishlistlength:0,
        wishlistdata:[],
        show:false
    },
    reducers:{
        wishlistlength: (state,action) => {
         state.wishlistlength = action.payload
        },
        wishlistdata: (state,action) => {
         state.wishlistdata = action.payload
        },
        showwishlist: (state,action) => {
         state.show = action.payload
        }
    }
})

export const { wishlistlength, wishlistdata, showwishlist} = wishSlice.actions
export default wishSlice.reducer